/**Conexion remota */
export const RUTA_SERVER = 'https://backfhj.onrender.com';
export const RUTA_SERVIDOR = 'https://backfhj.onrender.com/';
// export const RUTA_SERVER = 'http://localhost:4000';
// export const RUTA_SERVIDOR = 'http://localhost:4000/';
export const RUTA_IMG = 'https://fundacionhogarjuvenil.org/imgEcosistema/'
export const TITULO = 'Fundación Hogar Juvenil';
export const version = '2.5';

export const perfilFTP ={
  port: 21,
  host: 'ftp.fundacionhogarjuvenil.org',
  user: 'ftp_fhj@fundacionhogarjuvenil.org',
  password: 'JdFhj1972!'
}